<div class="body">
    <div class="appWrapper home">
        <div class="appbody">
            <div class="appbody-wrap position-relative">

                <div class="map position-relative">
                <img src="./assets/images/dealer_locator_map.png" alt="map" class="img-fluid" />
            </div>
                <div class="card menuCard">
                    <div class="card-body">
                        <h5 class="card-title fs-22 font-weight-bold  text-theme-green mb-4 pb-1 text-center">Dealer
                            Locator</h5>

                        <p class="fw-semibold fs-18 fw-semibold text-black mb-4">Please select product type</p>
                        <div class="card linkCard mb-3 pointer" style="cursor: pointer;">
                            <div class="card-body">
                                <div class="d-flex gap-3">
                                    <div class="flex-col flex-shrink-0">
                                        <img src="./assets/images/consumer-durables.svg" alt="consumer-durables"
                                            class="img-fluid" />
                                    </div>
                                    <div class="flex-col pl-3">
                                        <h5 class="card-title fs-18 font-weight-bold mt-3">Consumer Durables</h5>
                                        <!-- <p class="fs-13 mb-0">Link your spending to accurately and offset everything you
                                            buy</p> -->
                                    </div>
                                </div>
                            </div>
                            <a (click)="redirectToDearlerPage('CD')" class="stretched-link"></a>
                        </div>
                        <div class="card linkCard" style="cursor: pointer;">
                            <div class="card-body">
                                <div class="d-flex gap-3">
                                    <div class="flex-col flex-shrink-0">
                                        <img src="./assets/images/two-wheeler.svg" alt="Two Wheeler"
                                            class="img-fluid" />
                                    </div>
                                    <div class="flex-col pl-3">
                                        <h5 class="card-title fs-18 font-weight-bold mt-3">Two Wheeler</h5>
                                        <!-- <p class="fs-13 mb-0">Link your spending to accurately and offset everything you
                                            buy</p> -->
                                    </div>
                                </div>
                            </div>
                            <a (click)="redirectToDearlerPage('TW')" class="stretched-link"></a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
<loader *ngIf="loader"></loader>